import { Backdrop, Box, Button, List, ListItem, Snackbar } from "@mui/material";
import styles from "../../styles/components/bonusModal.module.scss";
import React from "react";
// import img from 'next/image'
import assest from "../../json/assest";
import ModalWrappperLargeOpacity from "../../ui/ModalWrapper/ModalWrapperLargeOpacity";

const bonusHistoryItem = [
  {
    date: "March 2023",
    time: "Mar 16, 2023 at 6:25PM UTC",
    doller: "$110",
    time1: "Mar 15, 2023 at 2:33PM UTC",
    doller1: "$50",
  },
  {
    date: "January 2023",
    time: "Jan 16, 2023 at 6:25PM UTC",
    doller: "$110",
    time1: "Mar 15, 2023 at 2:33PM UTC",
    doller1: "$50",
  },
];

const BonusModal = ({
  bonusAmount,
  handleConfirmBonus,
  bonusSnackOpen,
  handleCloseBonusSnack,
  handleCloseVideoBonus,
}) => {
  /**********************************/

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    handleCloseVideoBonus(false);
    handleCloseBonusSnack(false);
  };

  /**********************************/

  // const [openLargeOpacity, setOpenLargeOpacity] = React.useState(false);
  // const handleClickOpenLargeOpacity = () => {
  //   setOpenLargeOpacity(true);
  // };
  // const handleCloseLargeOpacity = () => {
  //   setOpenLargeOpacity(false);
  // };

  return (
    <Box className={styles.bonusModalWrapper}>
      <img src={assest.bonusModalImg} width={32} height={26} alt="" />
      <img src={assest.paymentIcon} width={32} height={26} alt="" />
      <p>
        Would you like to proceed with confirming the bonus payment of $
        {bonusAmount ? bonusAmount : "-"}?
      </p>

      <Box className={styles.paymentTxt}>
        <h4>
          Amount requested: <span>${bonusAmount ? bonusAmount : "-"}</span>
        </h4>
        <h4>
          PayPal: <span>paypal@viralsnare.com</span>
        </h4>
      </Box>

      <Box className={styles.bonusButtonGrp}>
        <Button className={styles.active} onClick={handleConfirmBonus}>
          Confirm
        </Button>
        <Button onClick={handleCloseVideoBonus}>Cancel</Button>
      </Box>

      {/*  <ModalWrappperLargeOpacity
        open={openLargeOpacity}
        onClose={handleCloseLargeOpacity}
        handleClose={handleCloseLargeOpacity}
        title={'Bonus History'}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.bonusHistoryWrapper}>
          {bonusHistoryItem.map((item, index) => {
            return (
              <Box className={styles.bonusHistoryList} key={index}>
                <h4>{item.date}</h4>
                <List>
                  <ListItem>
                    {item.time} <span>{item.doller}</span>
                  </ListItem>
                  <ListItem>
                    {item.time1} <span>{item.doller1}</span>
                  </ListItem>
                </List>
              </Box>
            );
          })}
        </Box>
      </ModalWrappperLargeOpacity> */}

      <Backdrop
        open={bonusSnackOpen}
        // sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        onClick={handleCloseSnack}
        sx={{ zIndex: "11" }}
        className={styles.snackBackDrop}
      >
        <Snackbar
          open={bonusSnackOpen}
          autoHideDuration={100000}
          onClose={handleCloseSnack}
          message={`Bonus Successfully Added`}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          ContentProps={{
            sx: {
              justifyContent: "center",
              minWidth: "246px !important",
              background: "#000",
              boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
              height: "45px",
              padding: "0",
              "& .MuiSnackbarContent-message": {
                fontWeight: "500",
                fontSize: "13px",
              },
            },
          }}
        />
      </Backdrop>
    </Box>
  );
};

export default BonusModal;
